import { SessionState } from "./store-ticket/storeTicket.reducer";

export const sessionSelector = (state: { session: SessionState }): string | undefined => {
    return state.session?.ticket;
};
